import React, { useState, useEffect } from 'react';
import Logo from '../../assets/Logo.svg';
import bgImage from "../../assets/back.png";
import { useNavigate } from 'react-router-dom';
const SignupPassword = () => {
  const [otp, setOtp] = useState(['', '', '', '']);
  const [timer, setTimer] = useState(20);
   const navigate = useNavigate();
  useEffect(() => {
    const countdown = setInterval(() => {
      setTimer(prev => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(countdown);
  }, []);

  const handleOtpChange = (index, value) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="flex flex-col items-center relative">
        <img src={Logo} alt="Logo" className="mb-4 w-[263px] z-10" />

        <div className="bg-white mb-4 rounded-2xl shadow-xl w-full sm:w-[384px] p-8 text-center">
          <h2 className="text-xl font-bold text-[#2D0076] mb-2">Please Check your email</h2>
          <p className="text-sm text-[#202224] mb-6">We have sent a code to johndoe@gmail.cm</p>

          <div className="flex justify-center gap-3 mb-4">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                className="w-12 h-12 text-center border border-gray-300 bg-[#F1F4F9] rounded-md text-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            ))}
          </div>

          <p className="text-sm text-gray-500 mb-6">
            Send code again <span className="text-black font-medium">00:{timer.toString().padStart(2, '0')}</span>
          </p>

          <button   onClick={() => navigate('/')}
            type="button"
            className="w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition"
          >
            Verify
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupPassword;
